import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import StatusBlock from '@/components/base/StatusBlock';
import { useAsyncData } from '@/hooks/useAsyncData';
import { getAllArticles, sortArticles } from '@/lib/content';
import type { Article } from '@/types/content';

function CardSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="h-44 w-full animate-pulse bg-background-100"></div>
      <div className="space-y-3 p-5">
        <div className="h-4 w-4/5 animate-pulse rounded bg-background-100"></div>
        <div className="h-3 w-full animate-pulse rounded bg-background-100"></div>
        <div className="h-3 w-2/3 animate-pulse rounded bg-background-100"></div>
      </div>
    </div>
  );
}

export default function LatestNews() {
  const { data, loading, error, reload } = useAsyncData<Article[]>(
    () => sortArticles(getAllArticles().filter((a) => a.type === 'news' || a.type === 'feature'), 'latest').slice(0, 6),
    [],
  );

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              LATEST NEWS
            </span>
            <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新影视资讯</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              聚合《疯狂试爱2》的最新动态与专题报道，按发布时间为你排列。
            </p>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {loading && (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <CardSkeleton key={i} />
            ))}
          </div>
        )}

        {!loading && error && (
          <StatusBlock
            icon="ri-wifi-off-line"
            title="网络异常"
            description={error}
            actionLabel="重新加载"
            onAction={reload}
          />
        )}

        {!loading && !error && data && data.length === 0 && (
          <StatusBlock icon="ri-inbox-archive-line" title="暂无最新资讯，敬请期待" />
        )}

        {!loading && !error && data && data.length > 0 && (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {data.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}